import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { SanitizedHtml } from "@/components/common/sanitized-html";
import { getTranscheckResult } from "@/features/admin/api";

/**
 * Transcript Check result (`/admin/transcheck`) — read-only HTML of the last
 * parser regression run + its error count. The parser that produces this lives
 * in Transcripts (2.3, a seam); here we just display the stored result and link
 * to the rules editor.
 */
export default function TranscheckPage() {
  const [check, setCheck] = useState("");
  const [errors, setErrors] = useState("");

  useEffect(() => {
    getTranscheckResult()
      .then((r) => {
        setCheck(r.check);
        setErrors(r.errors);
      })
      .catch(() => toast.error("Couldn't load the transcript-check result."));
  }, []);

  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between gap-4">
        <div>
          <CardTitle className="flex items-center gap-2">
            Transcript Check
            {errors && (
              <Badge variant={errors === "0" ? "secondary" : "destructive"}>
                {errors} error{errors === "1" ? "" : "s"}
              </Badge>
            )}
          </CardTitle>
          <CardDescription>Result of the last transcript-parse regression run.</CardDescription>
        </div>
        <Button asChild variant="outline" size="sm">
          <Link to="/admin/transcheck/rules">Edit Rules</Link>
        </Button>
      </CardHeader>
      <CardContent>
        {check ? (
          <SanitizedHtml html={check} />
        ) : (
          <p className="text-muted-foreground text-sm">
            No regression run recorded yet. The parser (Transcripts, Tier 2.3) writes the result
            here.
          </p>
        )}
      </CardContent>
    </Card>
  );
}
